import ChargePointListView, {
  ChargePointItem,
} from "./ChargePointListView/ChargePointListView";
import useChargePoint, {
  useSingleChargePoint,
} from "../../hooks/useChargePoint";
import { OrderByType } from "../../../../utils/genericAPI/useGenericAPI";
import { ChargePoint } from "../../types/stations.types";
import { LoaderSreen } from "../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import useQueryURL from "../../../../common/hooks/useQueryURL";
import NbConnector from "../ConnectorList/ConnectorList/NbConnector";
import SingleHardware from "../../../hardwares/components/SingleHardware";
import { ButtonWithComfirmationModal } from "../../../../common/components/organisme/ModalWindow/ModalWindow";
import { useAuth } from "../../../auth/hooks";
import { userRoles } from "../../../user/types/user.types";

export default function ChargePointListPresenter({
  stationId,
  orderBy,
  pageSize,
}: {
  pageSize?: number;
  orderBy?: OrderByType<ChargePoint>;
  stationId?: string;
}) {
  const {
    getAllBorneQuery: { isLoading, isError, data, error },
  } = useChargePoint({
    pageSize: pageSize,
    orderBy: orderBy,
    stationId: stationId,
  });

  const { setQueryValue } = useQueryURL();

  const chargePointFound: ChargePointItem[] | undefined = data?.data?.map(
    (chargePoint: ChargePoint) => {
      const handleClick = () => {
        setQueryValue({
          chargePointId: chargePoint.charge_point_id,
          singleChargePoint: "true",
        });
      };
      return {
        id: chargePoint.charge_point_id,
        name: chargePoint.charge_point_name,

        hardwareIDRender: () => (
          <SingleHardware.DevUID
            hardwareId={chargePoint.charge_point_hardware_id}
          />
        ),
        onClick: handleClick,
        nbConnector: () => (
          <NbConnector chargePointId={chargePoint.charge_point_id} />
        ),
        ActionBtnRender: () => (
          <ActionBtn
            idChargePoint={chargePoint.charge_point_id}
            stationId={stationId}
          />
        ),
      };
    }
  );
  return (
    <>
      {isLoading && <LoaderSreen heigth={"100px"} />}
      {isError && <ErrorScreenApp axiosError={error} />}
      {data && <ChargePointListView content={chargePointFound} />}
    </>
  );
}

const ActionBtn = ({
  idChargePoint,
  stationId,
}: {
  idChargePoint?: string;
  stationId?: string;
}) => {
  const {
    deleteChargePointQuery: deleteQ,
    singleChargePointQuery: { data },
  } = useSingleChargePoint({
    chargePointId: idChargePoint,
    stationId: stationId,
  });

  const { userRole } = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) {
    return <></>;
  }

  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <ButtonWithComfirmationModal
        titleModal="Suppression"
        desc={
          "Voulez-vous vraiment supprimer la borne " +
          data?.charge_point_name +
          "?"
        }
        height={"10px"}
        fontSize={"0.8rem"}
        borderRaduis={"10px"}
        variant={"outlined"}
        isLoading={deleteQ.isLoading}
        onClick={() => {
          deleteQ.mutate({});
        }}
        label="Supprimer"
        borderColor="#7C030370"
        fontColorHex="#7C030370"
        bgColorHex="transparent"
      />
    </div>
  );
};
